if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		// Helper function to convert remove anchor to button
		convertRemoveLinkToButton(remove, item) {
			if (!remove) return remove;
			// If it's already a button, just add the click handler
			if (remove.tagName === 'BUTTON') {
				// Ensure click handler is attached
				const existingHandler = remove.getAttribute('data-handler-attached');
				if (!existingHandler) {
					remove.setAttribute('data-handler-attached', 'true');
					remove.addEventListener('click', (e) => {
						e.preventDefault();
						e.stopPropagation();
						this.updateCartQty(item, 0);
						return false;
					});
				}
				return remove;
			}
			// If it's not an anchor, return as-is
			if (remove.tagName !== 'A') return remove;
			
			const button = document.createElement('button');
			button.className = remove.className;
			button.textContent = remove.textContent;
			button.setAttribute('type', 'button');
			button.setAttribute('role', 'button');
			button.setAttribute('tabindex', '0');
			button.setAttribute('title', remove.getAttribute('title') || '');
			
			// Copy all data attributes
			Array.from(remove.attributes).forEach(attr => {
				if (attr.name.startsWith('data-')) {
					button.setAttribute(attr.name, attr.value);
				}
			});
			
			// Store original href in data attribute for reference
			if (remove.href) {
				button.setAttribute('data-original-href', remove.href);
			}
			
			// Replace anchor with button
			remove.replaceWith(button);
			
			// Add click handler to button
			button.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				this.updateCartQty(item, 0);
				return false;
			});
			
			// Handle keyboard
			button.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					e.stopPropagation();
					this.updateCartQty(item, 0);
					return false;
				}
			});
			
			return button;
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			
			// Prevent form submission that might cause navigation, but allow checkout
			if (this.form) {
				this.form.addEventListener('submit', (e) => {
					// Allow checkout button to work - check if submit was triggered by checkout button
					const submitter = e.submitter;
					if (submitter && (submitter.name === 'checkout' || submitter.id === 'CheckOut')) {
						// This is a checkout submission, allow it to proceed
						return true;
					}
					// Also check form data as fallback
					if (e.target && new FormData(e.target).has('checkout')) {
						return true;
					}
					// Prevent other form submissions
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();
					return false;
				}, true);
				
				// Also prevent at bubble phase (but allow checkout)
				this.form.addEventListener('submit', (e) => {
					const submitter = e.submitter;
					if (submitter && (submitter.name === 'checkout' || submitter.id === 'CheckOut')) {
						// This is a checkout submission, allow it to proceed
						return true;
					}
					// Also check form data as fallback
					if (e.target && new FormData(e.target).has('checkout')) {
						return true;
					}
					e.preventDefault();
					e.stopPropagation();
					return false;
				}, false);
			}

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if (remove) {
					// Skip if handler already attached
					if (remove.hasAttribute('data-remove-handler-attached')) return;
					
					// Mark as having handler attached
					remove.setAttribute('data-remove-handler-attached', 'true');
					
					// Prevent default navigation for anchor tags
					if (remove.tagName === 'A') {
						// Set href to # to prevent navigation
						remove.setAttribute('href', '#');
						remove.addEventListener('click', (e) => {
							e.preventDefault();
							e.stopPropagation();
							e.stopImmediatePropagation();
							this.updateCartQty(item, 0);
							return false;
						});
					} else if (remove.tagName === 'BUTTON') {
						// Button - add click handler
						remove.addEventListener('click', (e) => {
						e.preventDefault();
							e.stopPropagation();
							e.stopImmediatePropagation();
						this.updateCartQty(item, 0);
							return false;
						});
					}
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					
					// Create a temporary container to parse the HTML and disable links BEFORE inserting
					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = cartFormInnerHTML;
					
					// Ensure all remove links have href="#" to prevent navigation
					tempDiv.querySelectorAll('[data-cart-remove-link], .remove').forEach(removeEl => {
						if (removeEl.tagName === 'A') {
							removeEl.setAttribute('href', '#');
						}
					});
					
					cartItems.innerHTML = tempDiv.innerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

// Immediately disable all remove links on page load to prevent navigation
(function() {
	function disableRemoveLinks() {
		document.querySelectorAll('[data-cart-remove-link], cart-form .remove, #AjaxCartForm .remove, .remove[href*="cart_change_url"]').forEach(remove => {
			const href = remove.getAttribute('href');
			if (href && href.includes('cart_change_url') && href.includes('quantity=0')) {
				if (!remove.dataset.originalHref && !remove.dataset.href) {
					remove.dataset.originalHref = href;
				}
				// Completely remove href to prevent any navigation
				remove.removeAttribute('href');
				remove.setAttribute('role', 'button');
				remove.setAttribute('tabindex', '0');
				
				// Add immediate click prevention
				if (!remove.dataset.prevented) {
					remove.dataset.prevented = 'true';
					remove.addEventListener('click', (e) => {
						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();
						return false;
					}, true);
				}
			}
		});
	}
	
	// Run immediately
	disableRemoveLinks();
	
	// Run on DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', disableRemoveLinks);
	}
	
	// Run after a delay to catch dynamically loaded content
	setTimeout(disableRemoveLinks, 50);
	setTimeout(disableRemoveLinks, 200);
})();

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}